import Vue from 'vue'

import {
  Button,
  Container,
  Header,
  Main,
  Aside,
  Footer,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Collapse,
  CollapseItem,
  Scrollbar,
  Input,
  Checkbox,
  CheckboxGroup,
  Table,
  TableColumn,
  Pagination,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Radio,
  RadioGroup,
  Form,
  FormItem,
  Upload,
  Message,
  Select,
  Option,
  Progress,
  Image,
  Divider,
  Link,
} from 'element-ui'

Vue.use(Button)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Aside)
Vue.use(Footer)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Submenu)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Scrollbar)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Upload)
Vue.use(Select)
Vue.use(Option)
Vue.use(Progress)
Vue.use(Image)
Vue.use(Divider)
Vue.use(Link)

Vue.prototype.$message = Message


// WEBPACK FOOTER //
// ./src/plugins/element.js